import React from "react";
import { useContentSetting } from "../../../Hooks/ContentSetting";
import Teaching from "./Teaching";
import { CAN_MANAGE_ROLES } from "./TutorsShell";

/**
 * Who is waiting on you, what you owe them, and the school's group classes.
 *
 * ONE NAV LABEL, ONE PAGE, CONTENTS BY ROLE.
 * Group Classes used to be a separate item so the front desk could reach it,
 * because a receptionist landing on a page called "Teaching" — a word for
 * something they do not do — was a category error. But two items for one
 * person's job was the bigger one: a class and a 1:1 are both a thing you turn
 * up and teach, both already sit on the same calendar, and an instructor had
 * to hold two pages in their head to see one week.
 *
 * So the split moved inside. A teacher gets the diary, the bay and their own
 * classes. Everyone else gets the classes and nothing else — which is exactly
 * what the front desk needed, and the reason they are not shut out: calling
 * off Thursday's class is their job, and hiding it is how eight students ended
 * up holding a booking for a class that was not happening.
 *
 * Role changes what is IN a page. It must never change what a page IS.
 *
 * SCOPE IS NOT COSMETIC. An instructor's list is narrowed to their own
 * classes, because GET /api/school/group-sessions is school-wide and an
 * unscoped list let a CFI cancel a colleague's evening — refunding eight seats
 * that were nothing to do with them. Managers keep the whole school, which is
 * the point of being one.
 */
export default function MyTeaching() {
  const { userInfo } = useContentSetting();
  const role = userInfo?.role;
  const canManage = CAN_MANAGE_ROLES.includes(role);
  const teaches = role === "instructor" || canManage;
  return <Teaching teaches={teaches} canManageAllClasses={canManage} />;
}
